import React, { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import emailjs from 'emailjs-com';
import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { resolveOrderEmail } from '../utils/orderUtils';

const OrderSummary = () => {
  const location = useLocation();
  let savedUserDetails = {};

  try {
    savedUserDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
  } catch (error) {
    savedUserDetails = {};
  }

  const locationState = location.state || {};
  const {
    products = [],
    finalAmount,
    email,
    mobile,
    additionalPhone,
    orderId,
    userDetails: navUserDetails = {},
  } = locationState;

  const userDetails = navUserDetails && Object.keys(navUserDetails).length ? navUserDetails : savedUserDetails;
  const resolvedEmail = resolveOrderEmail(locationState, userDetails, savedUserDetails);
  const filteredProducts = products.filter(product => product.quantity > 0);

  const handleDownloadPDF = useCallback(() => {
    const doc = new jsPDF();
    doc.setFont('times'); // Set font to Times New Roman
    doc.setFontSize(18);
    doc.text('Order Summary', 14, 20);
    doc.setFontSize(12);
    doc.text(`Order ID: ${orderId}`, 14, 30); // Display customOrderId

    // Name in left, Address in right
    doc.text(`Name: ${userDetails.name || ''}`, 14, 40);
    doc.text(`Email: ${resolvedEmail || ''}`, 14, 50);
    doc.text(`Mobile: ${mobile || ''}`, 14, 60);
    doc.text(`Address: ${userDetails.address || ''}`, 160, 40, { align: 'right' });

    const tableStartY = 70;
    const tableData = filteredProducts.map((product, index) => [
      index + 1,
      product.product_name,
      product.quantity,
      product.total_amount,
    ]);

    autoTable(doc, {
      head: [['No', 'Product Name', 'Quantity', 'Total Amount']],
      body: tableData,
      startY: tableStartY,
      styles: {
        font: 'times',
      },
    });

    // Add Final Amount at the bottom left and highlight it
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(14);
    doc.setTextColor(255, 0, 0);
    doc.text(`Final Amount: ${finalAmount}`, 14, finalY);

    // Add Payment Information
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    const paymentY = finalY + 20;
    doc.text('Payment Information:', 14, paymentY);
    doc.text(`GPay Number: 9789703090`, 14, paymentY + 10);
    
    // Add Bank Account Details
    doc.text('Bank Account Details:', 14, paymentY + 25);
    doc.setFontSize(10);
    doc.text('UCO BANK - NAME: VETRIVEL S', 14, paymentY + 35);
    doc.text('A/C NO: 18040110048603, IFSC: UCBA0001804', 14, paymentY + 45);
    doc.text('STATE BANK OF INDIA - NAME: S.VETRIVEL', 14, paymentY + 55);
    doc.text('A/C NO: 20188789602, IFSC: SBIN0009664', 14, paymentY + 65);
    doc.text('Contact: 7667533653 for delivery confirmation', 14, paymentY + 80);
    
    // Add Delivery Information
    doc.setFontSize(12);
    doc.text('Delivery Information:', 14, paymentY + 100);
    doc.setFontSize(10);
    doc.text('• Delivery within 1-2 days after payment', 14, paymentY + 110);
    doc.text('• Orders close 7 days before Diwali for Chennai/Bangalore/Coimbatore', 14, paymentY + 120);
    doc.text('• Sivakasi wholesale prices only', 14, paymentY + 130);

    doc.save(`OrderSummary_${orderId}.pdf`);
        // eslint-disable-next-line
  }, [filteredProducts, finalAmount, orderId, userDetails]); // Add dependencies

// eslint-disable-next-line
  const handleSendEmailAndWhatsApp = async () => {
    try {
      const recipientEmail = (resolvedEmail || email || '').trim();
      if (!recipientEmail) {
        alert('Email address is missing. Please enter your email before sending the order summary.');
        return;
      }

      const emailBody = `
  <h3>Order Summary</h3>
  <p><strong>Order ID:</strong> ${orderId}</p>
  <p><strong>Name:</strong> ${userDetails.name || ''}</p>
  <p><strong>Email:</strong> ${resolvedEmail || ''}</p>
  <p><strong>Mobile:</strong> ${mobile || ''}</p>
  <p><strong>Address:</strong> ${userDetails.address || ''}</p>
  <table style="border-collapse: collapse; width: 100%; margin-top: 20px;">
    <thead>
      <tr>
        <th style="border: 1px solid #ddd; padding: 8px;">No</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Product Name</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Quantity</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Total Amount</th>
      </tr>
    </thead>
    <tbody>
      ${filteredProducts
        .map(
          (product, index) => `
          <tr>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${product.product_name}</td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${product.quantity}</td>
            <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">₹${product.total_amount}</td>
          </tr>
        `
        )
        .join('')}
    </tbody>
  </table>
  <p style="margin-top: 20px; font-size: 16px; font-weight: bold; color: #FF4500;">
    Final Amount: ₹${finalAmount}
  </p>
  
  <div style="margin-top: 30px; padding: 20px; background-color: #d4edda; border: 1px solid #c3e6cb; border-radius: 10px;">
    <h4 style="color: #155724; margin-bottom: 15px;">🎉 Order Placed Successfully!</h4>
    
    <div style="display: flex; flex-wrap: wrap; gap: 20px;">
      <div style="flex: 1; min-width: 250px;">
        <h5 style="color: #007bff; margin-bottom: 10px;">📞 Contact Us for Delivery:</h5>
        <p style="margin: 5px 0;"><strong>Phone:</strong> 7667533653</p>
        <p style="margin: 5px 0;"><strong>WhatsApp:</strong> 7667533653</p>
      </div>
      
      <div style="flex: 1; min-width: 250px;">
        <h5 style="color: #007bff; margin-bottom: 10px;">💳 Payment Information:</h5>
        <p style="margin: 5px 0;"><strong>GPay Number:</strong> <span style="color: #28a745; font-weight: bold;">9789703090</span></p>
        <p style="margin: 5px 0; font-size: 12px; color: #666;">Send payment screenshot via WhatsApp after payment</p>
        
        <h6 style="color: #007bff; margin: 15px 0 10px 0;">🏦 Bank Account Details:</h6>
        
        <div style="background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 5px; padding: 10px; margin: 10px 0;">
          <p style="margin: 0; font-weight: bold; color: #495057;">UCO BANK</p>
          <p style="margin: 2px 0; font-size: 14px;">NAME: VETRIVEL S</p>
          <p style="margin: 2px 0; font-size: 14px;">A/C NO: 18040110048603</p>
          <p style="margin: 2px 0; font-size: 14px;">IFSC: UCBA0001804</p>
          <p style="margin: 0; font-size: 14px;">SIVAKASI BRANCH</p>
        </div>
        
        <div style="background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 5px; padding: 10px; margin: 10px 0;">
          <p style="margin: 0; font-weight: bold; color: #495057;">STATE BANK OF INDIA</p>
          <p style="margin: 2px 0; font-size: 14px;">NAME: S.VETRIVEL</p>
          <p style="margin: 2px 0; font-size: 14px;">A/C NO: 20188789602</p>
          <p style="margin: 2px 0; font-size: 14px;">IFSC: SBIN0009664</p>
          <p style="margin: 0; font-size: 14px;">SIVAKASI BRANCH</p>
        </div>
      </div>
    </div>
    
    <hr style="margin: 20px 0; border: 1px solid #c3e6cb;" />
    
    <div style="text-align: center;">
      <p style="margin: 10px 0; font-weight: bold; color: #856404;">
        ⚡ Important: Contact us immediately after placing order for delivery confirmation
      </p>
      <p style="margin: 0; color: #666; font-size: 14px;">
        Our team will coordinate with you for delivery timing and packing details
      </p>
    </div>
  </div>
  
  <div style="margin-top: 20px; padding: 15px; background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 8px;">
    <h5 style="color: #856404; margin-bottom: 10px;">🚚 Delivery Information:</h5>
    <ul style="margin: 0; padding-left: 20px; color: #856404;">
      <li>Crackers will be delivered within 1 to 2 days after successful payment completion</li>
      <li>For Chennai, Bangalore, Coimbatore - orders will be closed 7 days before Diwali</li>
      <li>All prices are Sivakasi wholesale crackers online prices only</li>
      <li>Please ensure someone is available at the delivery address during delivery hours</li>
      <li>Contact us immediately if you need to change delivery address or timing</li>
    </ul>
  </div>
`;

      // Send Email
      emailjs
        .send(
          'service_js2igxa',
          'template_m1ggcin',
          {
            to_email: recipientEmail,
            cc_email: 'karuppasamy1194@gmail.com',
            subject: 'Order Summary',
            html_body: emailBody,
          },
          'Sz6b-0Rmp0xVG3FjC'
        )
        .then(
          (response) => {
            console.log('Email sent successfully:', response.status, response.text);
            alert(`Order summary email sent successfully to ${recipientEmail} and karuppasamy1194@gmail.com!`);
          },
          (error) => {
            console.error('Failed to send email:', error);
            alert('Failed to send email. Please try again later.');
          }
        );
      // Send WhatsApp Messages using Meta's WhatsApp Cloud API
      const phoneNumbers = [`+91${mobile}`, `${additionalPhone}`];
      const accessToken = 'EAAVDjIxaytUBOzjZAkB7pIsfSZBKHi1FrlTaQiVgGEPLDYL1MOcK0RrMZA9xTDGYguKuLyuM5RIkwhoHXTSR9JN1vGdrMHYjFwCysLLZBzW1T1HKF4QZCEaWI8MhExXxoue6K3czdsFhIEuhZC4HcTGzb0UIiZAsqojtZAOceqBP1jYo4XCZAbV99K2bTzYeM0SiSuRqenjkvDZA5Big5eYCXaDxKB2p6U';
      const phoneNumberId = '540129502526626';

      const whatsappMessage = `🎉 Order Placed Successfully!

Order ID: ${orderId}
Final Amount: ₹${finalAmount}

📞 Contact for Delivery: 7667533653
💳 GPay Payment: 7667533653

🏦 Bank Account Details:

UCO BANK
NAME: VETRIVEL S
A/C NO: 18040110048603
IFSC: UCBA0001804
SIVAKASI BRANCH

STATE BANK OF INDIA
NAME: S.VETRIVEL
A/C NO: 20188789602
IFSC: SBIN0009664
SIVAKASI BRANCH

⚡ Please contact us immediately for delivery confirmation and send payment screenshot after payment.

🚚 Delivery Information:
• Delivery within 1-2 days after payment
• Orders close 7 days before Diwali for Chennai/Bangalore/Coimbatore  
• Sivakasi wholesale prices only

Thank you for choosing us! 🙏`;

      for (const phoneNumber of phoneNumbers) {
        try {
          const response = await axios.post(
            `https://graph.facebook.com/v15.0/${phoneNumberId}/messages`,
            {
              messaging_product: 'whatsapp',
              to: phoneNumber,
              type: 'text',
              text: { body: whatsappMessage },
            },
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
              },
            }
          );
          console.log(`WhatsApp message sent successfully to ${phoneNumber}:`, response.data);
          // alert(`WhatsApp message sent successfully to ${phoneNumber}!`);
        } catch (error) {
          if (error.response?.data?.error?.message.includes('Recipient phone number not in allowed list')) {
            // alert(`The phone number ${phoneNumber} is not in the allowed testing list. Please add it in the Meta Developer Dashboard.`);
          } else {
            console.error(`Failed to send WhatsApp message to ${phoneNumber}:`, error.response?.data || error.message);
            // alert(`Failed to send WhatsApp message to ${phoneNumber}. Please try again later.`);
          }
        }
      }
    } catch (error) {
      console.error('Failed to save order or send notifications:', error);
      alert('Failed to process the order. Please try again later.');
    }
    
  };

    // Call both methods only once when the component loads
  useEffect(() => {
    let emailsent = localStorage.getItem('emailsent');
    if(!emailsent){
        handleDownloadPDF();
        handleSendEmailAndWhatsApp();
    }

    localStorage.setItem('emailsent', true);
  }, [handleDownloadPDF, handleSendEmailAndWhatsApp]);

  return (
    <div className="container mt-4">
      <h2>Order Summary</h2>
      <div className="row mb-3">
        <div className="col-md-6 col-12">
          <p><strong>Name:</strong> {userDetails.name}</p>
          <p><strong>Email:</strong> {resolvedEmail || 'Not provided'}</p>
          <p><strong>Mobile:</strong> {mobile}</p>
        </div>
        <div className="col-md-6 col-12" style={{ textAlign: 'right' }}>
          <p><strong>Address:</strong> {userDetails.address}</p>
        </div>
      </div>
      <p><strong>Order ID:</strong> {orderId}</p>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>No</th>
            <th>Product Name</th>
            <th>Quantity</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map((product, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{product.product_name}</td>
              <td>{product.quantity}</td>
              <td>₹{product.total_amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <h4>Final Amount: ₹{finalAmount}</h4>
      
      {/* Payment and Delivery Information */}
      <div className="alert alert-success mt-4" style={{ 
        backgroundColor: '#d4edda', 
        border: '1px solid #c3e6cb', 
        borderRadius: '10px',
        padding: '20px'
      }}>
        <h5 className="alert-heading text-success mb-3">
          <i className="fas fa-check-circle"></i> Order Placed Successfully!
        </h5>
        <div className="row">
          <div className="col-md-6">
            <h6 className="text-primary">📞 Contact Us for Delivery:</h6>
            <p className="mb-2">
              <strong>Phone:</strong> <a href="tel:7667533653" className="text-decoration-none">7667533653</a>
            </p>
            <p className="mb-3">
              <strong>WhatsApp:</strong> <a href="https://wa.me/917667533653" target="_blank" rel="noopener noreferrer" className="text-decoration-none">7667533653</a>
            </p>
          </div>
          <div className="col-md-6">
            <h6 className="text-primary">💳 Payment Information:</h6>
            <p className="mb-2">
              <strong>GPay Number:</strong> <span className="text-success fw-bold">9789703090</span>
            </p>
            <p className="mb-3">
              <small className="text-muted">Send payment screenshot via WhatsApp after payment</small>
            </p>
            
            <h6 className="text-primary mt-3">🏦 Bank Account Details:</h6>
            <div className="card border-light mb-3" style={{ fontSize: '0.9rem' }}>
              <div className="card-body p-2">
                <p className="mb-1"><strong>UCO BANK</strong></p>
                <p className="mb-1">NAME: VETRIVEL S</p>
                <p className="mb-1">A/C NO: 18040110048603</p>
                <p className="mb-1">IFSC: UCBA0001804</p>
                <p className="mb-0">SIVAKASI BRANCH</p>
              </div>
            </div>
            
            <div className="card border-light" style={{ fontSize: '0.9rem' }}>
              <div className="card-body p-2">
                <p className="mb-1"><strong>STATE BANK OF INDIA</strong></p>
                <p className="mb-1">NAME: S.VETRIVEL</p>
                <p className="mb-1">A/C NO: 20188789602</p>
                <p className="mb-1">IFSC: SBIN0009664</p>
                <p className="mb-0">SIVAKASI BRANCH</p>
              </div>
            </div>
          </div>
        </div>
        <hr className="my-3" />
        <div className="text-center">
          <p className="mb-2 fw-bold text-warning">
            ⚡ Important: Contact us immediately after placing order for delivery confirmation
          </p>
          <p className="mb-0 text-muted">
            Our team will coordinate with you for delivery timing and packing details
          </p>
        </div>
      </div>

      <button className="btn btn-primary me-2" onClick={handleSendEmailAndWhatsApp}>
        Send Order Summary Email & WhatsApp
      </button>
    </div>
  );
};

export default OrderSummary;

